<template>
    <v-container fluid>
        <v-row align="start" justify="center">
            <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
                <v-toolbar height="50" dark color="#800000">
                    <v-toolbar-title>Student register</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon color="white"
                                v-on="on"
                                @click="gotoHome">
                                <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                        </template>
                        <span>close</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-text-field
                            prepend-icon="mdi-email"
                            name="email"
                            label="email"
                            type="text"
                            color="#800000"
                            v-model="email"
                            :rules="emailRules"
                        ></v-text-field>
                        <v-text-field
                            prepend-icon="mdi-lock"
                            name="password"
                            label="Password"
                            type="password"
                            color="#800000"
                            v-model="password"
                            :counter="6"
                            :rules="passRules"
                        ></v-text-field>
                    </v-form>
                    <v-row justify="center" class="redColor">{{error}}</v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small
                        class="text-capitalize"
                        dark color="#800000"
                        @click="onSubmit"
                        :loading="loading"
                        :disabled="!valid || loading"
                    >Registre</v-btn>
                </v-card-actions>
            </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
	export default {
		data () {
			return {
                email: '',
                password: '',
                valid: false, 
                error: '',
                emailRules: [ 
                    v => !!v || 'e-mail обязательный',
                    v => /.+@.+/.test(v) || 'некорректный формат e-mail'
                ],
                passRules: [
                    v => !!v || 'пароль обязательный',
                    v => (v && v.length >= 6) || 'пароль должен быть не менее 6 знаков'
                ]
            }	
		},
        computed: {
            loading () {
                return this.$store.getters.loading
            },
            isUserLoggedIn () {
                return this.$store.getters.isUserLoggedIn
            }
        },
        watch: {
            async isUserLoggedIn (val) {
                if (val) {
                    await this.$store.dispatch('logoutUser')
                    this.$router.replace('/login')
                }
            }
        },
		methods: {
            gotoHome () {
                this.$router.replace('/')
            },
			async onSubmit (){
                const user = {}

				if (this.$refs.form.validate()) {

                    user.email = this.email
                    user.password = this.password
				}

				//console.log(user)
                try {
                   await this.$store.dispatch('registerUser', user) 
                }
                catch(error) {
                    this.error = error.message
                }    
                //this.$router.push('/')                    
			}
		}
	}
</script>
<style scoped>

</style>